import React from 'react';

import analytics from 'analytics.js';
import config from 'config';

import PropTypes from 'prop-types';

// Analytics custimizations
import wootric from './wootric';

const customIntegrations = {
  wootric: wootric,
};
/**
 * Provides access to `analytics` within the applications
 * context and handles basic analytics tracking for page views
 * and user identification.
 */
class AnalyticsProvider extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
    client: PropTypes.object,
    children: PropTypes.node,
  };

  static childContextTypes = {
    analytics: PropTypes.object,
  };

  componentDidMount() {
    const { user, client } = this.props;

    let trackers = {};

    if (config.ANALYTICS) {
      for (let moduleName in config.ANALYTICS) {
        const module = config.ANALYTICS[moduleName];

        if (module) {
          trackers[module.ajsName] = module.options;
        }
      }

      analytics.initialize(trackers);
      analytics.identify(user.id, {
        ...user,
        company: {
          id: client.subdomain,
          name: client.displayName,
        },
      });
    }

    if (config.CUSTOM_ANALYTICS) {
      config.CUSTOM_ANALYTICS.forEach(custom => {
        if (customIntegrations[custom]) {
          customIntegrations[custom](user);
        }
      });
    }

    // Display Intercom button if support is enabled
    setTimeout(() => {
      this.toggleIntercom(this.props);
    }, 3000);
  }

  componentDidUpdate(nextProps) {
    this.toggleIntercom(nextProps);
  }

  toggleIntercom(props) {
    const intercomElem = window.document.getElementById('intercom-container');
    if (intercomElem) {
      if (props.supportEnabled === true) {
        intercomElem.style.display = 'hidden';
      } else {
        intercomElem.style.display = 'block';
      }
    }
  }

  getChildContext() {
    return {
      analytics: analytics,
    };
  }

  render() {
    return this.props.children;
  }
}

export default AnalyticsProvider;
